import AppPopover from "@/components/AppPopover";
import StateSwitch from "@/components/StateSwitch";
import Alert from "@/components/icons/Alert.vue";
import PlayIcon from "@/components/icons/PlayIcon.vue";
import PauseIcon from "@/components/icons/PauseIcon.vue";
export default {
  name: "PpcBAStateCell",
  emits: ["state-change"],
  components: {
    AppPopover,
    StateSwitch,
    Alert,
    PlayIcon,
    PauseIcon
  },
  props: {
    item_id: {
      type: String,
      default: ""
    },
    state: {
      type: (Boolean, String),
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    State: {
      get() {
        return this.state;
      },
      set(val) {
        this.$emit('state-change', val);
      }
    }
  }
};